import { googleAPI } from "../../config.js";

var GoogleAuth;

export const initDrive = async () => {
  try {
    await new Promise((res, rej) => {
      window.gapi.load("client:auth2", { callback: res, onerror: rej });
    });
    await window.gapi.client.init({
      apiKey: googleAPI.API_KEY,
      client_id: googleAPI.CLIENT_ID,
      scope: "https://www.googleapis.com/auth/drive.file",
      discoveryDocs: [
        "https://www.googleapis.com/discovery/v1/apis/drive/v3/rest",
      ],
    });
    GoogleAuth = window.gapi.auth2.getAuthInstance();
  } catch (e) {
    console.log(e);
  }
};

export const isSignedIn = () => {
  if (!GoogleAuth) return false;
  return GoogleAuth.isSignedIn.get();
};

export const listenAuthState = (func) => {
  GoogleAuth.isSignedIn.listen(func);
};

export const handleAuth = () => {
  GoogleAuth.signIn();
};

export const handleSignOut = () => {
  GoogleAuth.signOut();
};

export const checkFolder = async () => {
  try {
    const drive = window.gapi.client.drive;
    const res = await drive.files.list({
      q:
        "mimeType = 'application/vnd.google-apps.folder' and name = 'WEBOS_FOLDER' and trashed = false",
      fields: "files(id, name)",
      spaces: "drive",
    });
    const folders = res.result.files;
    if (folders.length === 1) {
      return { error: false, folderId: folders[0].id };
    } else if (folders.length === 0) {
      const metadata = {
        name: "WEBOS_FOLDER",
        mimeType: "application/vnd.google-apps.folder",
      };
      const res = await drive.files.create({
        resource: metadata,
        fields: "id",
      });
      return { error: false, folderId: res.result.id };
    } else {
      return { error: true };
    }
  } catch (e) {
    console.log(e);
    return { error: true };
  }
};

export const createDriveFile = async (folderId, blob) => {
  try {
    const metadata = {
      name: blob.name,
      parents: [folderId],
    };
    let form = new FormData();
    form.append(
      "metadata",
      new Blob([JSON.stringify(metadata)], { type: "application/json" })
    );
    var accessToken = GoogleAuth.currentUser.get().getAuthResponse(true)
      .access_token;
    form.append("file", blob);
    const res = await fetch(
      "https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart&fields=id",
      {
        method: "POST",
        headers: new Headers({ Authorization: "Bearer " + accessToken }),
        body: form,
      }
    );
    const result = await res.json();
    return { error: false, fileId: result.id };
  } catch (e) {
    console.log(e);
    return { error: true };
  }
};

export const getDriveFile = async (fileId) => {
  try {
    const drive = window.gapi.client.drive;
    await drive.permissions.create({
      fileId: fileId,
      resource: {
        role: "writer",
        type: "anyone",
      },
    });
    const res = await drive.files.get({
      fileId: fileId,
      fields: "webViewLink",
    });

    return { error: false, fileId, fileUrl: res.result.webViewLink };
  } catch (e) {
    console.log(e);
    return { error: true };
  }
};

export const deleteDriveFile = async (fileId) => {
  try {
    const drive = window.gapi.client.drive;
    await drive.files.delete({
      fileId: fileId,
    });
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true };
  }
};
